import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { Layout } from './components/Navigation';
import Home from './pages/Home';

const Services = lazy(() => import('./pages/Services'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact').then(module => ({ default: module.Contact })));
const Admin = lazy(() => import('./pages/Admin').then(module => ({ default: module.Admin })));
const Terms = lazy(() => import('./pages/Terms'));
const TermsInvoicing = lazy(() => import('./pages/TermsInvoicing'));

export default function App() {
  return (
    <Router>
      <Layout>
        <Suspense fallback={<div className="flex min-h-[50vh] items-center justify-center text-sm text-gray-600">Loading…</div>}>
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms/" element={<Terms />} />
          <Route path="/terms-and-conditions" element={<TermsInvoicing />} />
          <Route path="/terms-and-conditions/" element={<TermsInvoicing />} />
          <Route path="/terms-invoicing" element={<TermsInvoicing />} />
          <Route path="/terms-invoicing/" element={<TermsInvoicing />} />
          <Route path="/swaroop-gateway-2026" element={<Admin />} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}
